import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from "../Services/auth.service";
import { CommonService } from "../Services/common.service";
import { TopupServiceService } from "../Services/topup-service.service";
import { CookieService } from '../Services/cookie';
import { AccountService } from "../Services/account.service";
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: "app-type-of-pay",
  templateUrl: "./type-of-pay.component.html",
  standalone:false,
  styleUrls: ["./type-of-pay.component.scss"],
})
export class TypeOfPayComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  selectedType: string = "";
  Typelist;
  idnumber: string;
  CardDigit: number;
  Accnum:string;
  Accountno: number;
  amount: number;
  selectedMethod: string = "";
  selectedamounttype: string = "";
  Methodlist;
  mobileno;

  inquirypay: boolean = false;
  amountdetail;
  prodType: string;
  TopupInquire: any;
  cardPay: string="directcard";

  constructor(
    private cookieService: CookieService,
    private _router: Router,
    private location: Location,
    public auth: AuthService,
    private commonP: CommonService,
    private topup: TopupServiceService,
    private account: AccountService,
    private cdr: ChangeDetectorRef
  ) {}
  back() {
    this.location.back();
  }

  async ngOnInit(): Promise<any> {

    this.cookieService.set("directCardpay", "",true);
    this.auth.accessToken = await this.commonP.Get("token");

    let P =await this.cookieService.get("prodType", true);
    if (P) {
    
      
      this.prodType = P;
        console.log(this.prodType,"productagaya");
        this.cdr.detectChanges();
    }

    let d =await this.cookieService.get("CVa21f11", true);
    if (d) {
      this.idnumber = d;
    }
     
  }

  onTypeChange(event) {
    this.selectedType = event.displayValue;
    console.log("selectedType", this.selectedType);
  }

 


  showModal(num) {
    this.modalObservable.next(num);
  }

  // isValid() {
  //   let CardDigitStr = this.CardDigit != undefined ? this.CardDigit.toString() : '';
  //   let AccnumStr = this.Accnum != undefined ? this.Accnum.toString() : '';
  
  //   let CardDigitlen = this.prodType == 'C' ? CardDigitStr.length : 0;
  //   let Accnumlen = this.prodType == 'L' ? AccnumStr.length : 0;
  
  //   if (this.prodType == 'C' && CardDigitStr && CardDigitlen == 4) {
  //     return false;
  //   } else if (this.prodType == 'L' && AccnumStr && Accnumlen > 5) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }

  isValid() {
    let CardDigitStr = this.CardDigit != undefined ? this.CardDigit.toString() : '';
    let AccnumStr = this.Accnum != undefined ? this.Accnum.toString() : '';
  
    // Allow only numbers
    const onlyNumbersRegex = /^[0-9]*$/;
  
    let CardDigitlen = this.prodType == 'C' ? CardDigitStr.length : 0;
    let Accnumlen = this.prodType == 'L' ? AccnumStr.length : 0;
  
    // Validate CardDigit case
    if (this.prodType == 'C' && CardDigitStr && CardDigitlen == 4 && onlyNumbersRegex.test(CardDigitStr)) {
      return false;
    }
  
    // Validate Accnum case
    if (this.prodType == 'L' && AccnumStr && Accnumlen > 5 && onlyNumbersRegex.test(AccnumStr)) {
      return false;
    }
  
    return true;
  }
  
  

 


  payCard() {

    let body ={
      IdNumber: this.idnumber,
      UniqueId:this.commonP.Guid(),
      AccountType: this.prodType,
      MobileNumber: "",
      AccountNumber: this.prodType == 'C'? this.CardDigit.toString():this.Accnum.toString(),
      isInquire: false
    }
   this.commonP.presentLoading();
   this.topup.TopupInquire(body).then((data: any) => {
    if (data?.response?.code == 1) {
      //
      this.TopupInquire = data?.response?.content;

      console.log('TopupInquireResponse', this.TopupInquire)

      if(this.prodType =='C'){
      
        // this.cookieService.set("CardDigit", this.CardDigit.toString(), false,undefined,undefined,undefined,undefined,true,"Strict");
         this.cookieService.set("Dix2lf4",this.CardDigit.toString(),true);
        this.cookieService.set("MaxPayment", this.TopupInquire.maxPaymntAmount ,true);
        this.cookieService.set("UdF1", this.TopupInquire.udF1 , true);
        this.cookieService.set("UDF2", this.TopupInquire.uDF2 ,true);

      }
      else if(this.prodType =='L'){
   
        // this.cookieService.set("Accnum", this.Accnum,false,undefined,undefined,undefined,undefined,true,"Strict");
        // new
        this.cookieService.set("tu42f",this.Accnum,true);
        this.cookieService.set("MaxPayment", this.TopupInquire.maxPaymntAmount ,true);
        this.cookieService.set("UdF1", this.TopupInquire.udF1 ,true);
        this.cookieService.set("UDF2", this.TopupInquire.uDF2 ,true);
      }
      this.commonP.hideLoading();
    
      this.cookieService.set("directCardpay", this.cardPay,true);
      this._router.navigateByUrl('/PayCard')


    } else {
      //
      this.commonP.hideLoading();
      this.commonP.ParseErrorAlert("", "", this._router, data);
    }
  });

  }


  MobileNumber() {


    this.cookieService.set("flow", 'Inquire',true);
    if(this.prodType == 'C'){
      // this.cookieService.set("CardDigit", this.CardDigit.toString(), false,undefined,undefined,undefined,undefined,true,"Strict");
      this.cookieService.set("Dix2lf4",this.CardDigit.toString(),true);

    }
    else{
      // this.cookieService.set("Accnum", this.Accnum, false,undefined,undefined,undefined,undefined,true,"Strict");
      this.cookieService.set("tu42f",this.Accnum,true);
    }


    this._router.navigateByUrl("/MobileNumber");
  }
}
